import React, {useState, useEffect} from "react";
import FormInput from "./FormInput";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from "react-toastify";
import {useForm} from "react-hook-form"
import api from "../../../api/api";

const CompanySearch = ({ register }) => {
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    
    api.get(`/services/company/`)
    .then(response => {
      setSearchData(
        response.data.map(({ company_name: name, id }) => ({ name, id }))
      );
    })
    .catch(error=> {
      console.log(error)
    })

  }, [])

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    // console.log(string, results)
  };

  const handleOnHover = (result) => {
    // the item hovered
    // console.log(result)
  };

  const handleOnSelect = (item) => {
    // the item selected
    console.log(item)
   
  };
  
  const handleOnFocus = () => {
    // console.log('Focused')
  };
  

  const formatResult = (item) => {
    return (
      <>
        {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
        <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
      </>
    );
  };



  return (
    <div className="  ">
      <div className="flex flex-col item-center md:relative border-2 p-3 w-[16rem] md:w-[35rem] border-primary-blue">
          <p className=" text-primary-red font-Laila md:text-lg font-bold">
            कम्पनी वा ब्यवसायको नाम:
          </p>
        <div  className="md:absolute md:right-1 md:top-1 w-[15rem] md:w-[20rem]  ">
                    <ReactSearchAutocomplete
                      items={searchData}
                      onSearch={handleOnSearch}
                      onHover={handleOnHover}
                      onSelect={handleOnSelect}
                      onFocus={handleOnFocus}
                      autoFocus
                      formatResult={formatResult}
                      placeholder="Search Company"
                    />
          </div>
        {/* <input
          className=" border-2 text-primary-blue pl-5 font-bold  border-primary-red outline-none rounded-xl"
          type="search"
          placeholder="Search"
          {...register("company_name", { required: false })}
        /> */}
      </div>
    </div>
  );
};

export default CompanySearch;
